<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
import { useSystemStore } from '@/client/store/useSystemStore'

export default defineComponent({
  components: {
    Icon
  },
  computed: {
    ...mapState(useSystemStore, ['user', 'currentGroup'])
  }
})
</script>

<template>
  <div class="container">
    <Icon v-if="user" :name="user.name" :picture-url="user.pictureUrl" />
    <div class="info">
      <span v-if="user">
        {{ user.name }}
      </span>
      <span v-if="currentGroup" class="group">
        {{ currentGroup.name }}
      </span>
    </div>
    <i class="mdi mdi-menu-down" />
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.container {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
  justify-content: center;
  color: $text-color-white;
  cursor: pointer;
}

.info {
  display: flex;
  flex-direction: column;
}

.group {
  font-size: $font-small-size;
  line-height: 16px;
  color: $sub-text-color;
}
</style>
